import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import { ThemeProvider } from './theming/provider';
import { HomeScreen, ButtonScreen, DrawerScreen, ModalScreen, RatingScreen, TooltipScreen, InputScreen, ToastScreen, ComponentScreen  } from './screens';
import './App.css';


function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes >
          <Route path="/" element={<HomeScreen />}/>
          <Route path="/button" element={<ButtonScreen />}/>
          <Route path="/drawer" element={<DrawerScreen />}/>
          <Route path="/modal" element={<ModalScreen />} />
          <Route path='/rating' element={<RatingScreen />} />
          <Route path='/tooltip' element={<TooltipScreen />} />
          <Route path='/input' element={<InputScreen />} />
          <Route path='/toast' element={<ToastScreen />} />
          {/* <Route path="/screen" element={<ComponentScreen>{<></>}</ComponentScreen>} /> */}
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
